import { useSelector } from 'react-redux'
import { RootState } from 'store'

export function useWsConnection() {
  return useSelector<RootState, number>((state) => state.ws.connection)
}

export function useWsToken() {
  return useSelector<RootState, string>((state) => state.ws.token)
}

export function useWsLost() {
  return useSelector<RootState, number>((state) => state.ws.lost)
}
export function usePingTime() {
  return useSelector<RootState, number>((state) => state.ws.pingTime)
}
export function useLatencyMillisecond() {
  return useSelector<RootState, number>((state) => state.ws.latency)
}
